<div role="tablist" class="aa-dash-tabgroup">
  @for (tab of tabs; track tab) {
    <div class="aa-dash-tab" [class.disabled]="tab.disabled" [class.active]="tab.active">
      <div [style.height.px]="height" class="aa-dash-tab-title" (click)="onClickTab(tab)">
        {{tab.title}}<ng-template [ngTemplateOutlet]="$safeNavigationMigration(tab.titleTpl?.templateRef)"></ng-template>
      </div>
      <div class="aa-dash-tab-border"></div>
    </div>
  }
</div>
<div class="aa-dash-tab-content">
  @for (tab of tabs; track tab) {
    @if (tab.active) {
      <div role="dashtabpanel" [attr.aria-labelledby]="tab.id" id="{{tab.id}}-panel"
        >
        <ng-template [ngTemplateOutlet]="$safeNavigationMigration(tab.contentTpl?.templateRef)"></ng-template>
      </div>
    }
  }
</div>
